// extracted by mini-css-extract-plugin
export default {"reminder":"Reminder_reminder__VZ+gq","time":"Reminder_time__pxnzZ","item":"Reminder_item__R0+6B","label":"Reminder_label__craDb","overDue":"Reminder_overDue__DSuOM"};